import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useOutlet } from "react-router-dom";
import { useRedux } from "../../hooks/useRedux";
import { Footer } from "../../components/templates";
import Text from "../../utils/dictionaries/dictionary-laborInformation-client";
import Top from "../../components/templates/topV2";
import Title from "../../components/atoms/titleV2";
import Select from "../../components/molecules/select";
import Spinner from "../../components/atoms/spinnerV2";
import { onLaborInformation } from "../../redux/slices/clientInformation";
import validationSchema from "./schema";
import UtilsCommonsService from "../../services/utilsCommons.service";
import { useApi } from "../../hooks/useApi";
import { ICatalog } from "../../interfaces/api/IUtilsCommons.interface";
import { useFollowLater } from "../../hooks/useFollowLater";
import { useModalError } from "../../hooks/useModalError";
import './style.scss';

const UTILSCOMMONSSERRVICE = new UtilsCommonsService();

const LaborInformationClient = () => {
  const { isModaError , modaComponente, setIsModalError} = useModalError()
  const { getProfesionTDD, getGiroAltoRiesgo } = UTILSCOMMONSSERRVICE;
  const { onClickContinue } = useFollowLater();
  const navigate = useNavigate();
  const {
    data: dataSelectOccupation = [],
    execute: executeProfesionTDD,
    isLoading: isLoadingProfesionTDD,
    error:isErrorProfesionTDD,
  } = useApi<ICatalog[], { processId: string }>(getProfesionTDD);
  const {
    data: dataSelectActivities = [],
    execute: executeGetGiroAltoRiesgo,
    isLoading: isLoadingGiroAltoRiesgo,
    error:isErrorGiroAltoRiesgo,
  } = useApi<ICatalog[], { processId: string }>(getGiroAltoRiesgo);

  const {
    data: {
      clientPersist: { uuid },
      clientInformation: { laborInformation },
    },
    dispatch,
  } = useRedux();

  const formik = useFormik({
    initialValues: {
      occupation: laborInformation.occupation,
      occupationKey: laborInformation.occupationKey,
      activities: laborInformation.activities,
      activitiesKey: laborInformation.activitiesKey ,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => console.log(values),
    enableReinitialize: true,
  });

  useEffect(() => { 
    return () => {
      executeProfesionTDD({ processId: uuid });
      executeGetGiroAltoRiesgo({ processId: uuid });
    };
  }, []);


  useEffect(() => { 
    if((isErrorGiroAltoRiesgo && !isLoadingGiroAltoRiesgo) || (isErrorProfesionTDD && !isLoadingProfesionTDD) ){
      setIsModalError(true);
    }
  }, []);

  const onOk = () => {
    dispatch(onLaborInformation({ ...formik.values }));
    onClickContinue({
      data: formik.values,
      processId: uuid,
      resource: "/LaborInformation",
      step: "CONTINUE",
    });
    navigate("/UseAccountManagement");
  };

  const btnDisabled = (): boolean => {
    let retVal = true;

    if (formik.values.occupationKey && formik.values.activitiesKey) {
      retVal = false;
    } else {
      retVal = true;
    }

    return retVal;
  };

  const onClickButtonLink = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/LaborInformation",
        step: "CONTINUE_AFTER",
        data: formik.values,
      },
    });
    dispatch(onLaborInformation({ ...formik.values }));
  };

  return (
    <>
      <Top
        titleHeader={Text.top.titleHeader}
        subTitle={Text.top.subTitle}
        displayLeftImageTitle={"d-block"}
        displayProgressBar={"d-block"}
        classHeader={"mt-2"}
        classProgressBar={"mt-3"}
        valueProgressBar={"50%"}
        onClickGoBackIcon={() => navigate("/FiscalInformationClient")}
      />

      <main className="container_form mb-4_3">
        <div className=" mb-4">
          <Title text={Text.title.titleText} className={"container_form__title"} />
        </div>
        {isLoadingGiroAltoRiesgo && isLoadingProfesionTDD ? (
          <Spinner />
        ) : (
          <>
            <div className="mt-4">
              <Select
                defaultValue={formik.values.occupationKey}
                value={formik.values.occupationKey}
                placeholder={Text.selectOccupation.title}
                data={dataSelectOccupation.map((key) => ({
                  value: key.key,
                  label: key.description,
                }))}
                onChange={(e: any) =>{ 
                    const occupation = dataSelectOccupation.find((data) => (data.key === e.target.value));
                    formik.setFieldValue("occupation", occupation?.description);
                    formik.setFieldValue("occupationKey", e.target.value);
                  }
                }
              />
            </div>
            <div className="mt-4">
              <Select
                defaultValue={formik.values.activitiesKey}
                value={formik.values.activitiesKey}
                placeholder={Text.selectActivities.title}
                data={dataSelectActivities.map((key) => ({
                  value: key.key,
                  label: key.description,
                }))}
                onChange={(e: any) => {
                    const activity = dataSelectActivities.find((data) => (data.key === e.target.value));
                    formik.setFieldValue("activities", activity?.description);
                    formik.setFieldValue("activitiesKey", e.target.value)
                  }
                }
              />
            </div>
          </>
        )}
      </main>
      <Footer
        activeSpinner={false}
        disabledButton={btnDisabled()}
        onClickButtonPrimary={() => onOk()}
        labelButtonPrimary={Text.button.labelButtonPrimary}
        labelButtonSecundary={Text.button.labelButtonSecundary}
        onClickButtonLink={() => onClickButtonLink()}
      />
      {modaComponente}
    </>
  );
};

export default LaborInformationClient;
